import api from './api';

const daccaBaseURL = '/dacca';

export function getDaccaCalculations(caseCode: string) {
  return api.get(`${daccaBaseURL}/calculation/${caseCode}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getDaccaCalculationsDetails(calculationVersionId: number) {
  return api.get(`${daccaBaseURL}/calculation-details/${calculationVersionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getDaccaToken() {
    return api.post(`/dacca/token`).catch(err => {
    console.error(err);
    return err;
  });

}
